//环境变量(dev feat test prod)
const env = process.env.REACT_APP_ENV;

//地址配置
const api = {};
const url = {};
if(env === 'dev') {
  api.gateway = '//gateway-dev.36kr.com/api';
  api.base = '//misopen-dev.36kr.com/api';              //当前系统
  api.assist = '//assist-dev.corp.36kr.com/api';         //公共服务
  api.gassist = '//assist-dev.corp.36kr.com/gapi';       //上传服务
  url.sso = '//misopen-dev.36kr.com';                   //权限系统
  url.mrs = '//mrs-dev.corp.36kr.com';                   //资源系统
  url.mis = '//mis-dev.corp.36kr.com';                   //内部系统
  url.web = '//test02.36kr.com';                         //36氪主站
  url.retail = '//retail-dev01.36kr.com';                //零售老板内参h5
}else if(env === 'feat') {
  api.base = '//misopen-feat.36kr.com/api';
  api.assist = '//assist-test.corp.36kr.com/api';
  api.gassist = '//assist-test.corp.36kr.com/gapi';
  url.sso = '//misopen-feat.36kr.com';
  url.mrs = '//mrs-feat.corp.36kr.com';
  url.web = '//test02.36kr.com';
  url.retail = '//retail-test01.36kr.com';
} else if(env === 'feat2') {                             // feat预发布环境
  api.base = '//misopen-feat2.36kr.com/api';
  api.assist = '//assist-feat2.corp.36kr.com/api';
  api.gassist = '//assist-feat2.corp.36kr.com/gapi';
  url.sso = '//misopen-feat2.36kr.com';
  url.mrs = '//mrs-feat2.corp.36kr.com';
  url.web = '//test02.36kr.com';
  url.retail = '//retail-test01.36kr.com';
}else if(env === 'test') {
  api.gateway = '//gateway-test.36kr.com/api';
  api.base = '//misopen-test.36kr.com/api';
  api.assist = '//assist-test.corp.36kr.com/api';
  api.gassist = '//assist-test.corp.36kr.com/gapi';
  url.sso = '//misopen-test.36kr.com';
  url.mrs = '//mrs-test.corp.36kr.com'; 
  url.mis = '//mis-test.corp.36kr.com'; 
  url.web = '//test02.36kr.com';
  url.retail = '//retail-test01.36kr.com';
} else if(env === 'pre') {
  api.gateway = '//gateway-pre.36kr.com/api';
  api.base = '//misopen-pre.36kr.com/api';
  api.assist = '//assist-pre.corp.36kr.com/api';
  api.gassist = '//assist-pre.36kr.com/api';
  url.sso = '//misopen-pre.36kr.com';
  url.mrs = '//mrs-pre.corp.36kr.com';
  url.mis = '//mis-pre.corp.36kr.com';  
  url.web = '//pre.36kr.com';
  url.retail = '//retail-pre.36kr.com';
} else if(env === 'prod') {
  api.gateway = '//gateway.36kr.com/api';
  api.base = '//misopen.36kr.com/api';
  api.assist = '//assist.corp.36kr.com/api';
  api.gassist = '//assist.36kr.com/api';
  url.sso = '//misopen.36kr.com';
  url.mrs = '//mrs.corp.36kr.com'; 
  url.mis = '//mis.corp.36kr.com';  
  url.web = '//www.36kr.com';
  url.retail = '//retail.36kr.com';
};

export {
  api,
  url
}
